import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPaste$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPaste extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '62bec16ec2c2a6dbcc39046d5c8d4094193a40dd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '71203f671334659ec0a057ab9fbd65327d1d9a2c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4fb69cfff8c2d6004f375c783cce27420cc0448c', d: "M10.5 3.5A.5.5 0 0 1 11 3h3a.5.5 0 0 1 .5.5V4H17a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V15a.5.5 0 0 1 .5-.5h1v-9H9v1a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 8 4h2.5z", fill: "currentColor" }), h("path", { key: '09c79b71a1d540b4d9b1596357e1e6b2ef4624e0', d: "M4.5 8.5A.5.5 0 0 1 5 8h8a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-paste", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-paste"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-paste":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPaste$1);
            }
            break;
    } });
}

const CosmosIconPaste = CosmosIconPaste$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPaste, defineCustomElement };
